import { Box, CircularProgress, Typography } from '@ace-clublabs/shared-component-library';
import Header from '../components/Header';

const Spinner: React.FC = () => {
  return (
    <>
      <Header />
      <Box
        sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '24px' }}
        className="inner-container processing"
      >
        <CircularProgress aria-label="progress" id="spinner" variant="indeterminate" sx={{ marginBottom: '16px' }} />
        <Typography variant="b1Regular" component="h1" className="processingText">
          Hang tight while we get things ready for you.
        </Typography>
      </Box>
    </>
  );
};

export default Spinner;
